import script from "./CommentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentItem.vue?vue&type=script&setup=true&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=62ca1481&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ca1481"]])

export default __exports__